import type { MessagingTemplate } from "../types";

/**
 * Template → "exige questionário?"
 *
 * Regra atual:
 * - Se BODY/HEADER contiverem a variável `questionnaire_link`, o usuário deve selecionar
 *   um questionário antes do envio.
 *
 * Observação:
 * - Mantemos a regra simples e explícita para evitar inferências escondidas na UI.
 * - Esta função é pura e fácil de evoluir (ex.: múltiplas variáveis).
 */

export const QUESTIONNAIRE_LINK_VARIABLE_NAME = "questionnaire_link";

function textIncludesQuestionnaireVariable(text: string): boolean {
  const normalized = String(text ?? "").toLowerCase();
  // Variáveis do WhatsApp no projeto seguem o padrão `{{var}}`.
  return normalized.includes(`{{${QUESTIONNAIRE_LINK_VARIABLE_NAME}}}`);
}

export function doesTemplateRequireQuestionnaire(
  template: MessagingTemplate | null | undefined,
): boolean {
  if (!template) return false;

  const hasInBody = textIncludesQuestionnaireVariable(template.preview);
  if (hasInBody) return true;

  const headerText = String(template.header ?? "").trim();
  return headerText ? textIncludesQuestionnaireVariable(headerText) : false;
}

